export default {"src":"/_next/static/media/navbarmenuicon.86125096.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};